


































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';

@Component({
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('UserPreference', {
      userPreference: 'single',
    }),
  },
})
export default class BusinessUpdatePreference extends Vue {
  activeBusiness!: Model;
  userPreference!: Model | null;

  tmp: Model | null = null;

  switchButtonAttributes = [
    'ghc_booking_candidate_status_enabled',
    'monthly_booking_summary_email_enabled',
    'booking_reminder_email_enabled',
  ];

  attributeLabels = {
    ghc_booking_candidate_status_enabled:
      'model.user_preference.ghc_booking_candidate_status_enabled_label',
    monthly_booking_summary_email_enabled:
      'model.user_preference.monthly_booking_summary_email_enabled_label',
    booking_reminder_email_enabled:
      'model.user_preference.booking_reminder_email_enabled_label',
  };

  attributeHints = {
    ghc_booking_candidate_status_enabled:
      'model.user_preference.ghc_booking_candidate_status_enabled_hint',
    monthly_booking_summary_email_enabled:
      'model.user_preference.monthly_booking_summary_email_enabled_hint',
    booking_reminder_email_enabled:
      'model.user_preference.booking_reminder_email_enabled_hint',
  };

  created() {
    if (!this.userPreference) {
      this.$store
        .dispatch('UserPreference/fetch', this.activeBusiness.object_id)
        .then(() => {
          this.tmp = cloneDeep(this.userPreference);
        });
    } else {
      this.tmp = cloneDeep(this.userPreference);
    }
  }

  renderLabel(attribute) {
    if (!(attribute in this.attributeLabels)) {
      return null;
    }

    return this.$t(this.attributeLabels[attribute]);
  }

  renderHint(attribute) {
    if (!(attribute in this.attributeHints)) {
      return null;
    }

    return this.$t(this.attributeHints[attribute]);
  }

  updatePreference() {
    this.$store.dispatch('UserPreference/update', {
      oid: this.activeBusiness.object_id,
      payload: {
        ...this.tmp,
      },
    });
  }
}
